// routes/renderRoutes.js

import { Route } from "react-router-dom";

export const renderRoutes = (routes) =>
  routes.map((route) => {
    if (route.children) {
      return (
        <Route key={route.path} path={route.path} element={route.element}>
          {renderRoutes(route.children)}
        </Route>
      );
    }

    return (
      <Route
        key={route.path || "index"}
        index={route.index}
        path={route.path}
        element={route.element}
      />
    );
  });
